
import { defineComponent } from 'vue'

/**
 * Component to show deleted user account or team account intermediate state
 */
export default defineComponent({
  name: 'DeletedAccountState',
  props: {
    accountType: {
      type: String,
      default: 'team',
      validator: (value: string) => ['team', 'account'].includes(value)
    }
  }
})
